"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFile = void 0;
const File_1 = require("./File");
const isFile = (value) => value instanceof File_1.File;
exports.isFile = isFile;
